(function (angular) {
    angular
        .module('one.admin')
        .directive('datetimeInput', datetimeInputDirective);

    datetimeInputDirective.$inject = ['$locale', 'dateFilter', 'moment'];

    function datetimeInputDirective($locale, dateFilter, moment) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                var parsedDateFormat = $locale.DATETIME_FORMATS.parsedDateTime;
                var formattedDateFormat = $locale.DATETIME_FORMATS.userInputDateTime;

                ngModel.$parsers = [parseValue];
                ngModel.$formatters = [formatValue];

                ngModel.$validators.datetime = validateDatetime;

                element.on('blur', updateViewValue);

                function parseValue(value) {
                    return value ? moment(value, formattedDateFormat).format(parsedDateFormat) : null;
                }

                function formatValue(value) {
                    return value ? moment(value, parsedDateFormat).format(formattedDateFormat) : null;
                }

                function validateDatetime(modelValue, viewValue) {
                    return ngModel.$isEmpty(viewValue) || moment(modelValue, parsedDateFormat).isValid();
                }

                function updateViewValue() {
                    if (ngModel.$valid) {
                        ngModel.$setViewValue(formatValue(ngModel.$modelValue));
                        ngModel.$render();
                    }
                }
            }
        };
    }
})(angular);
